import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from "./data.service";
import { ApiService } from './api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'yes-bank-gift-card';
  logIn = false;

  constructor(
    private router: Router,
    private dataService: DataService,
    private apiService: ApiService,
  ) { };

  ngOnInit() {
    this.apiService.setBaseURL();
    const userObj = JSON.parse(localStorage.getItem("userObj"));
    let pathName = window.location.pathname;
    if (userObj && userObj.loggedIn) {
      if (userObj.userDetail) this.dataService.setCardType(userObj.userDetail.cardType);
      if (pathName === '/') this.router.navigate(['/home']);
    } else {
      if (pathName === '/login/virtual-card') this.router.navigate(['/login/virtual-card'])
      else if (pathName === '/login/physical-card') this.router.navigate(['/login/physical-card'])
      else this.router.navigate(['/login']);
    }
  }
}
